import React from 'react';
import { kazanimEtiketi } from '../lib/dersler';

/**
 * BenzerlikRozeti — korpus-içi benzeşim uyarısı.
 *
 * ⚠️ YENİDEN KURULDU (2026-09-04, kullanıcı isteği + ölçüm). Öncesinde canlı panelde
 * commit'li ilk sürüm koşuyordu ve rozet HAM KOSİNÜSÜ basıyordu:
 *
 *     ⧉ Benzer: #{komsu} ({cosine.toFixed(2)})
 *
 * Kullanıcı bu yüzden "#18799-#26375 benzerlik oranı 0,97, birini silelim" dedi.
 * İki gövde okununca ortaya çıktı ki o çift KOPYA DEĞİL: 14/6/5 ikizkenar yamuk ile
 * 18/8/13 ikizkenar yamuk, farklı ifadeler, farklı cevap (A / E), gövde oranı 0,58.
 * Ortak olan yalnız "ikizkenar yamuk + I/II/III" kalıbıydı.
 *
 * ÖLÇÜM (canlı DB, 4647 komşulu çift, 2026-09-04) — kosinüsün neyi ölçtüğü:
 *
 *     kosinüs \ gövde   <0,40   0,40-0,60   0,60-0,80   >=0,80    toplam
 *     <0,80               851         181          35        4      1071
 *     0,80-0,90           631         310          63       12      1016
 *     0,90-0,95           476        1065         395       47      1983
 *     >=0,95               14         182         286       95       577
 *
 * Eski rozet kosinüs >= 0,90 olan 2560 çiftin HEPSİNE basıyordu; bunların yalnız
 * 142'sinde gövde >= 0,80 idi — isabet ~%5,5. Aynı kapı ters yönde de yanılıyordu:
 * gövdesi >= 0,80 olan 16 çift kosinüs bandının ALTINDA kaldığı için hiç görünmüyordu
 * ve çoğu ONAYLIydı (#31554~#31603 kos 0,751 gövde 0,905, ikisi de 5 puan;
 * #32144~#32691 kos 0,803 gövde 0,898, 7 ve 6 puan).
 *
 * NEDEN GÖVDE, NEDEN GÖVDE+ŞIK DEĞİL — elle etiketlenmiş 10 çiftte ölçüldü
 * (6 kopya / 4 kopya-değil; gövdeler tek tek okundu):
 *
 *     ölçüt                    KOPYA min   değil max   ayırıyor mu?
 *     gövde+şık (eski tasarım)   0,733       0,842     HAYIR — örtüşüyor
 *     yalnız şık                 0,189       0,870     HAYIR
 *     yalnız GÖVDE               0,878       0,872     evet (dar)
 *
 * Şıklar biçim gürültüsü taşıyor: #31271~#35157 aynı sorunun iki yazımıdır, doğru
 * cevap aynı sayıdır (4,8 = 24/5), ama şık oranı 0,189. Bu yüzden ölçü YALNIZ gövdedir.
 *
 * ⚠️ ROZET HÜKÜM VERMEZ (Y1). Gövde ölçüsü kopyayı kalıp tekrarından temiz ayırmıyor:
 * ayrım boşluğu 10 örnekte yalnız 0,006. Buna otomatik "kopya" hükmü kurmak, güvenilir
 * ölçülemeyen kriteri canlıya almak olurdu. Rozet bu yüzden KIYASLAMAYA ÇAĞIRIR:
 * eşi gösterir, oranı verir, tıklayınca yan yana koyar — kararı öğretmen verir.
 *
 * KISA GÖVDE TUZAĞI: gövde tek cümleyse tek kelime değişimi oranı şişirir.
 * #28278 "…hoşgörü anlamı çıkarılabilir?" ile #30193 "…alçakgönüllülük anlamı
 * çıkarılabilir?" gövde oranı 0,872 — ama iki FARKLI sorudur (83 karakter). Bu yüzden
 * `govde_uzunluk < KISA_GOVDE` olan çift asla "kıyasla" rengine çıkmaz.
 *
 * Veri yazıcısı: `scripts/benzerlik_metin_orani.py` (ETIKET govde_olcum_2026-09-04).
 * Eşikler orada değişirse burada da değişmeli.
 */

/** Rozetin görünme eşiği — gövde oranı. */
export const GOVDE_ESIK = 0.60;
/** Bu oranın üstü "önce bunu kıyasla" demektir; KOPYA HÜKMÜ DEĞİLDİR. */
export const GOVDE_KIYAS_ESIK = 0.85;
/** Bu uzunluğun altındaki gövdede oran güvenilmez (normalize edilmiş karakter). */
export const KISA_GOVDE = 120;
/** Eşi kayıtlı olmayan skorun gösterim eşiği (metin ölçülemez, nötr rozet). */
export const ISARET_ESIK = 0.90;

const sayi = (v) => {
  if (v == null) return NaN;
  const n = Number(v);
  return Number.isFinite(n) ? n : NaN;
};

/**
 * Soru satırından {komsu, govde, uzunluk, cosine, kisaGovde, kiyasAdayi} çıkarır.
 * Eşik altındaysa null döner (rozet basılmaz).
 */
export function benzerlikBilgisi(s) {
  if (!s) return null;
  const kd = s.kaynak_detay && typeof s.kaynak_detay === 'object' ? s.kaynak_detay.benzerlik : null;

  const cosine = sayi(kd && kd.cosine != null ? kd.cosine
    : (s.benzerlik_cosine != null ? s.benzerlik_cosine : s.benzerlik_skoru));
  const komsu = Number(kd && kd.komsu != null ? kd.komsu : s.benzerlik_komsu) || null;

  // EŞİ KAYITLI OLMAYAN SKOR — metin kıyaslanacak soru yok. Ölçüm (2026-08-29):
  // 694 kayıt, tamamı `sorular` tablosunda. Kosinüs tek başına kopya kanıtı
  // olmadığı için bu dal renk vermez, bağ vermez; yalnız "bir eşi olabilir" der.
  if (!komsu) {
    if (!Number.isFinite(cosine) || cosine < ISARET_ESIK) return null;
    return { komsu: null, govde: null, uzunluk: null, cosine, kisaGovde: false, kiyasAdayi: false };
  }

  const govde = sayi(kd && kd.govde_orani != null ? kd.govde_orani : s.benzerlik_govde);
  // GÖVDE ÖLÇÜLMEMİŞSE ROZET BASILMAZ. Kosinüse geri düşmek, bu dosyanın düzelttiği
  // hatanın ta kendisidir — ölçülmemiş kaydı "benzer" diye göstermek yanlış alarmdır.
  if (!Number.isFinite(govde) || govde < GOVDE_ESIK) return null;

  const uzunluk = sayi(kd && kd.govde_uzunluk != null ? kd.govde_uzunluk : s.benzerlik_govde_uzunluk);
  // Uzunluk bilinmiyorsa TEDBİRLİ davran: kısa say, "kıyasla" rengine çıkarma.
  const kisaGovde = !Number.isFinite(uzunluk) || uzunluk < KISA_GOVDE;

  const ayniKaz = kd && kd.ayni_kazanim != null ? !!kd.ayni_kazanim
    : String(s.benzerlik_ayni_kazanim) === 'true';
  const ayniCev = kd && kd.ayni_cevap != null ? !!kd.ayni_cevap
    : String(s.benzerlik_ayni_cevap) === 'true';

  return {
    komsu, govde, uzunluk, cosine, kisaGovde, ayniKaz, ayniCev,
    kiyasAdayi: govde >= GOVDE_KIYAS_ESIK && !kisaGovde,
  };
}

export default function BenzerlikRozeti({ soru, kompakt = false }) {
  const b = benzerlikBilgisi(soru);
  if (!b) return null;

  const olcu = kompakt ? 'px-1.5 py-0.5 text-[9px]' : 'px-2.5 py-1 text-xs';

  if (!b.komsu) {
    return (
      <span
        className={`inline-block rounded font-semibold border bg-gray-100 text-gray-600 border-gray-300 ${olcu}`}
        title={`Korpus benzerlik skoru ${b.cosine.toFixed(4)} — bu soru, kendi dersinin vektör `
          + 'koleksiyonundaki başka bir soruya bu oranda benziyor. Eşin numarası bu kayıtta '
          + 'saklanmamış, o yüzden metin kıyaslaması yapılamıyor ve tıklanacak bağ yok. '
          + 'Kosinüs ÖSYM kalıp cümlelerini de sayar (ölçüm: kosinüsü 0,90 üstü olan '
          + '2560 çiftin yalnız 142\'sinde gerçek gövde benzerliği 0,80\'i geçiyor) — '
          + 'TEK BAŞINA KOPYA KANITI DEĞİLDİR.'}
      >
        Korpus benzerliği {b.cosine.toFixed(2)} · eşi kayıtlı değil
      </span>
    );
  }

  const yuzde = Math.round(b.govde * 100);
  const renk = b.kiyasAdayi
    ? 'bg-red-100 text-red-800 border-red-300'
    : 'bg-orange-100 text-orange-800 border-orange-300';

  const baslik = `En yakın eşi #${b.komsu}. Soru GÖVDESİ %${yuzde} örtüşüyor`
    + (Number.isFinite(b.cosine) ? ` (vektör kosinüsü ${b.cosine.toFixed(4)} — kosinüs kalıp `
      + 'cümleleri de saydığı için karar ölçüsü DEĞİL, bilgi olarak veriliyor).' : '.')
    + ` ${kazanimEtiketi(soru)} ${b.ayniKaz ? 'AYNI' : 'farklı'}, doğru cevap ${b.ayniCev ? 'AYNI' : 'farklı'}. `
    + (b.kisaGovde
      ? `⚠️ Gövde kısa (${Number.isFinite(b.uzunluk) ? b.uzunluk : '?'} karakter); kısa metinde `
        + 'tek kelime değişimi oranı şişirir, bu yüzden oran düşük güvenlidir. '
      : '')
    + (b.kiyasAdayi
      ? 'ÖNCE BUNU KIYASLA: gövde örtüşmesi yüksek. '
      : 'Benzer görünüyor. ')
    + 'Bu rozet KOPYA HÜKMÜ VERMEZ — ölçüm, kopyayı kalıp tekrarından güvenilir biçimde '
    + 'ayıramadığını gösterdi (ayrım boşluğu 0,006). Tıklayınca eş soru süzülür; kararı siz verin.';

  return (
    <a
      href={`?public_no=${b.komsu}`}
      title={baslik}
      onClick={(e) => e.stopPropagation()}
      className={`inline-block rounded font-bold border ${renk} ${olcu} no-underline hover:brightness-95 cursor-pointer`}
    >
      ⧉ {b.kiyasAdayi ? 'Kıyasla' : 'Benzer'}: #{b.komsu} · gövde %{yuzde}{b.kisaGovde ? ' ⚠' : ''}
    </a>
  );
}
